import { useState } from "react";

export const useModal = (): [boolean, () => void, () => void] => {
  const [visible, setVisible] = useState<boolean>(false);
  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);
  return [visible, openModal, closeModal];
};
